import styled from 'styled-components';

export default styled.div.attrs({ className: 'BreakLine' })`
    hr {
        border:none;
        border-top: ${props => props.thickness}px ${props => props.type} ${props => props.color};
    }
`;
